// Cardholder self-serve card replacement (DH-3013, BP-246). Copy from the BP-246 mockup.
// {hrb, select, ...} picks the support wording: HRB publishes a number, {phone}, rendered as a
// call link; every other company says "contact support". <lead> is a bold lead-in on its own
// line; <link> is the activation page. {fee} and the other amounts are already formatted for
// the cardholder's locale; {from} and {to} are dates.
export const cardReplacementEn = {
  'replace-card-button': 'Replace card',
  'replace-card-in-progress-title': 'A replacement is already on the way',
  'replace-card-heading': 'Replace your card',
  'replace-card-step-reason': 'Reason',
  'replace-card-step-delivery': 'Delivery',
  'replace-card-step-confirm': 'Confirm',
  'replace-card-ineligible':
    'You don\'t have enough funds for this transaction. Contact the organization that sends money to this card to add funds, then try again.',
  'replace-card-unavailable':
    'Card replacement isn\'t available right now. {hrb, select, yes {Call {phone}} other {Contact support}} and we\'ll help.',
  'replace-card-quote-failed':
    'We couldn\'t load your replacement details. Try again later, or {hrb, select, yes {call {phone}} other {contact support}}.',
  'replace-card-already-ordered':
    'A replacement for this card is already on the way. You can\'t order another one until it arrives and is activated.',
  // Step 1: reason
  'replace-card-reason-label': 'Why are you replacing it?',
  'replace-card-reason-lost': 'Lost',
  'replace-card-reason-stolen': 'Stolen',
  'replace-card-reason-damaged': 'Damaged or not working',
  'replace-card-dispute-alert':
    '<lead>Do you see transactions you don\'t recognize?</lead>{hrb, select, yes {Call {phone}} other {Contact support}} to file a dispute. You can do this before or after you order your replacement.',
  // Step 2: delivery
  'replace-card-delivery-heading': 'Where should we send it?',
  'replace-card-address-label': 'Mailing address on file',
  'replace-card-method-label': 'Delivery method',
  'replace-card-method-standard': 'Standard mail',
  'replace-card-delivery-message':
    'Your card will arrive {from} to {to} business days after it is processed.',
  'replace-card-current-balance': 'Current balance',
  'replace-card-fee': 'Replacement fee',
  'replace-card-balance-after': 'Balance after',
  'replace-card-disclosures-heading': 'Before you continue',
  'replace-card-disclosure-1':
    'Your current card is disabled right away and can\'t be reactivated, even if you find it.',
  'replace-card-disclosure-2':
    'You won\'t be able to use your funds with a card until the new one arrives.',
  'replace-card-disclosure-3': 'A fee applies ({fee}) and is taken from your balance.',
  'replace-card-acknowledge': 'I understand and want to continue',
  // Step 3: confirm
  'replace-card-confirm-heading': 'Confirm it\'s you',
  'replace-card-summary-reason': 'Reason',
  'replace-card-summary-mail-to': 'Mail to',
  'replace-card-summary-reason-lost': 'Lost',
  'replace-card-summary-reason-stolen': 'Stolen',
  'replace-card-summary-reason-damaged': 'Damaged',
  'replace-card-summary-fee': 'Fee',
  'replace-card-password-label': 'Password',
  'replace-card-password-placeholder': 'Enter your password',
  'replace-card-cancel-warning':
    '<b>This permanently cancels your card ending {lastFour}.</b> It can\'t be undone.',
  'replace-card-wrong-password': 'That password is incorrect. Try again.',
  'replace-card-step-up': 'For your security, enter your password again.',
  'replace-card-submit-button': 'Replace card',
  'replace-card-submitting': 'Ordering your replacement…',
  'replace-card-submitting-hint': 'Please keep this window open.',
  // Outcome
  'replace-card-success-title': 'Your card is on the way!',
  'replace-card-success-expected': 'Expected between {from} and {to}.',
  'replace-card-success-hint':
    'Your account now shows the new card. It can\'t be used until it arrives and you activate it.',
  'replace-card-failed':
    '<lead>We couldn\'t order your replacement.</lead>Your card has not been cancelled and you haven\'t been charged. Try again, or {hrb, select, yes {call {phone}} other {contact support}}.',
  'replace-card-try-again': 'Try again',
  'replace-card-back': 'Back',
  'replace-card-continue': 'Continue',
  'replace-card-close': 'Close',
  'replace-card-cancel': 'Cancel',
  'replace-card-loading': 'Loading your replacement details…',
  'replace-card-loading-hint': 'Checking your eligibility and the replacement fee.',
  'replace-card-done': 'Back to home',
  // Activate dialog, opened from the banner
  'activate-card-heading': 'Activate your card',
  'activate-card-intro': 'Enter the details printed on your new card.',
  'activate-card-cancel': 'Cancel',
  'activate-card-submit': 'Activate card',
  'activate-card-submitting': 'Activating your card…',
  'activate-card-success-title': 'Your card is active',
  'activate-card-success-hint': 'You can start using your new card now.',
  'activate-card-already-title': 'This card is already active',
  'activate-card-already-hint': 'There is nothing more to do; you can use it now.',
  'activate-card-done': 'Back to home',
  // Dashboard banner while the replacement is in progress: within the delivery window, then
  // once its last day has passed. {lastFour} is "none" when the old card is not known.
  'replace-card-on-the-way-alert':
    '<b>Your replacement card is on the way.</b> Expected {from} to {to}. {lastFour, select, none {} other {Your old card ending {lastFour} is cancelled. }}If you have already received it, <link>activate it here</link>.',
  'replace-card-overdue-alert':
    '<b>Your replacement card should have arrived by {to}.</b> {lastFour, select, none {} other {Your old card ending {lastFour} is cancelled. }}If you have received it, <link>activate it here</link>. If not, {hrb, select, yes {call support at {phone}} other {contact support}}.',
};

// French: pending translation review.
export const cardReplacementFr = {
  'replace-card-button': 'Remplacer la carte',
  'replace-card-in-progress-title': 'Une carte de remplacement est déjà en route',
  'replace-card-heading': 'Remplacer votre carte',
  'replace-card-step-reason': 'Motif',
  'replace-card-step-delivery': 'Livraison',
  'replace-card-step-confirm': 'Confirmation',
  'replace-card-ineligible':
    'Vous n\'avez pas suffisamment de fonds pour cette transaction. Communiquez avec l\'organisation qui verse de l\'argent sur cette carte pour ajouter des fonds, puis réessayez.',
  'replace-card-unavailable':
    'Le remplacement de carte n\'est pas offert pour le moment. {hrb, select, yes {Appelez le {phone}} other {Communiquez avec le soutien}} et nous vous aiderons.',
  'replace-card-quote-failed':
    'Nous n\'avons pas pu charger les détails de votre remplacement. Réessayez plus tard ou {hrb, select, yes {appelez le {phone}} other {communiquez avec le soutien}}.',
  'replace-card-already-ordered':
    'Une carte de remplacement est déjà en route. Vous ne pouvez pas en commander une autre avant qu\'elle arrive et soit activée.',
  'replace-card-reason-label': 'Pourquoi la remplacez-vous?',
  'replace-card-reason-lost': 'Perdue',
  'replace-card-reason-stolen': 'Volée',
  'replace-card-reason-damaged': 'Endommagée ou ne fonctionne pas',
  'replace-card-dispute-alert':
    '<lead>Voyez-vous des transactions que vous ne reconnaissez pas?</lead>{hrb, select, yes {Appelez le {phone}} other {Communiquez avec le soutien}} pour déposer une contestation. Vous pouvez le faire avant ou après avoir commandé votre carte de remplacement.',
  'replace-card-delivery-heading': 'Où devons-nous l\'envoyer?',
  'replace-card-address-label': 'Adresse postale au dossier',
  'replace-card-method-label': 'Mode de livraison',
  'replace-card-method-standard': 'Courrier ordinaire',
  'replace-card-delivery-message':
    'Votre carte arrivera de {from} à {to} jours ouvrables après son traitement.',
  'replace-card-current-balance': 'Solde actuel',
  'replace-card-fee': 'Frais de remplacement',
  'replace-card-balance-after': 'Solde après',
  'replace-card-disclosures-heading': 'Avant de continuer',
  'replace-card-disclosure-1':
    'Votre carte actuelle est désactivée immédiatement et ne peut pas être réactivée, même si vous la retrouvez.',
  'replace-card-disclosure-2':
    'Vous ne pourrez pas utiliser vos fonds avec une carte avant l\'arrivée de la nouvelle.',
  'replace-card-disclosure-3': 'Des frais s\'appliquent ({fee}) et sont prélevés sur votre solde.',
  'replace-card-acknowledge': 'Je comprends et je veux continuer',
  'replace-card-confirm-heading': 'Confirmez votre identité',
  'replace-card-summary-reason': 'Motif',
  'replace-card-summary-mail-to': 'Envoyer à',
  'replace-card-summary-reason-lost': 'Perdue',
  'replace-card-summary-reason-stolen': 'Volée',
  'replace-card-summary-reason-damaged': 'Endommagée',
  'replace-card-summary-fee': 'Frais',
  'replace-card-password-label': 'Mot de passe',
  'replace-card-password-placeholder': 'Saisissez votre mot de passe',
  'replace-card-cancel-warning':
    '<b>Cette action annule définitivement votre carte se terminant par {lastFour}.</b> Elle ne peut pas être annulée.',
  'replace-card-wrong-password': 'Ce mot de passe est incorrect. Réessayez.',
  'replace-card-step-up': 'Pour votre sécurité, saisissez de nouveau votre mot de passe.',
  'replace-card-submit-button': 'Remplacer la carte',
  'replace-card-submitting': 'Commande de votre carte de remplacement…',
  'replace-card-submitting-hint': 'Veuillez garder cette fenêtre ouverte.',
  'replace-card-success-title': 'Votre carte est en route!',
  'replace-card-success-expected': 'Arrivée prévue entre le {from} et le {to}.',
  'replace-card-success-hint':
    'Votre compte affiche maintenant la nouvelle carte. Elle ne pourra pas être utilisée avant son arrivée et son activation.',
  'replace-card-failed':
    '<lead>Nous n\'avons pas pu commander votre carte de remplacement.</lead>Votre carte n\'a pas été annulée et aucuns frais ne vous ont été facturés. Réessayez ou {hrb, select, yes {appelez le {phone}} other {communiquez avec le soutien}}.',
  'replace-card-try-again': 'Réessayer',
  'replace-card-back': 'Retour',
  'replace-card-continue': 'Continuer',
  'replace-card-close': 'Fermer',
  'replace-card-cancel': 'Annuler',
  'replace-card-loading': 'Chargement des détails de votre remplacement…',
  'replace-card-loading-hint': 'Vérification de votre admissibilité et des frais de remplacement.',
  'replace-card-done': 'Retour à l\'accueil',
  'activate-card-heading': 'Activer votre carte',
  'activate-card-intro': 'Entrez les renseignements imprimés sur votre nouvelle carte.',
  'activate-card-cancel': 'Annuler',
  'activate-card-submit': 'Activer la carte',
  'activate-card-submitting': 'Activation de votre carte…',
  'activate-card-success-title': 'Votre carte est active',
  'activate-card-success-hint': 'Vous pouvez commencer à utiliser votre nouvelle carte dès maintenant.',
  'activate-card-already-title': 'Cette carte est déjà active',
  'activate-card-already-hint': 'Il n\'y a rien d\'autre à faire; vous pouvez l\'utiliser dès maintenant.',
  'activate-card-done': 'Retour à l\'accueil',
  'replace-card-on-the-way-alert':
    '<b>Votre carte de remplacement est en route.</b> Arrivée prévue entre le {from} et le {to}. {lastFour, select, none {} other {Votre ancienne carte se terminant par {lastFour} est annulée. }}Si vous l\'avez déjà reçue, <link>activez-la ici</link>.',
  'replace-card-overdue-alert':
    '<b>Votre carte de remplacement aurait dû arriver au plus tard le {to}.</b> {lastFour, select, none {} other {Votre ancienne carte se terminant par {lastFour} est annulée. }}Si vous l\'avez reçue, <link>activez-la ici</link>. Sinon, {hrb, select, yes {appelez le soutien au {phone}} other {communiquez avec le soutien}}.',
};
